module.exports = __webpack_public_path__ + "static/media/10.e11b764a.mp3";